import datejs from 'date-and-time';
import { Medlemskapstype } from './api/medlemskapAPI';
import { MedlemskapTypeId } from './MedlemskapType/MedlemskapTypeId';
export const CURRENT_ENVIRONMENT = process.env.PUBLIC_URL.includes('prod') ? 'prod' : 'test';

export function calculateAge(dateOfBirth: string) {
    const birth = new Date(datejs.parse(dateOfBirth, 'DD.MM.YYYY'));
    const difference = Date.now() - birth.setHours(23, 59, 59); //Setting hours as calculation apparently depends on hours on birth date being later than hours from date.now to be correct. Miscalculated when birth date is next day from actual current date
    const ageDate = new Date(difference);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function getMedlemskapstypeById(
    medlemskapstypeList: Medlemskapstype[],
    id: string
): Medlemskapstype | undefined {
    return medlemskapstypeList.find((medlemskap) => medlemskap.id === id);
}

export function medlemskapstypeIdFromAge(age: number): string {
    if (age < 18) {
        return MedlemskapTypeId.EnkeltBarn;
    } else if (age < 30) {
        return MedlemskapTypeId.EnkeltUngVoksen;
    } else if (age < 67) {
        return MedlemskapTypeId.Enkelt;
    } else {
        return MedlemskapTypeId.EnkeltSenior;
    }
}

export function medlemskapstypeIdFromAgeHusstand(age: number): string {
    if (age > 26) {
        return MedlemskapTypeId.Husstand;
    } else {
        return MedlemskapTypeId.HusstandBarn;
    }
}

export function medlemskapstypeIsLivsvarig(medlemskapstype: Medlemskapstype | undefined) {
    if (!medlemskapstype) {
        return false;
    }
    return medlemskapstype.id === MedlemskapTypeId.Livsvarig;
}

export const ageSegments = ['0-17 år', '18-29 år', '30-66 år', 'over 67 år'];
